import { btn, h } from '../ui/icons';
import { modalFocus } from '../ui/modalFocus';
import type { EngraveSession } from './EngraveSession';
import { ew, fontPicker } from './parts';

/** Shared bottom drawer: the complete font catalogue and its six family filters. */
export class FontDrawer {
  readonly trigger = btn('mt-eng-font-trigger');
  readonly root = h('div', 'mt-font-overlay');
  private readonly picker;
  private release: (() => void) | null = null;
  constructor(private readonly session: EngraveSession) {
    const w = ew();
    this.trigger.setAttribute('aria-haspopup', 'dialog'); this.trigger.setAttribute('aria-expanded', 'false');
    this.root.hidden = true;
    const sheet = h('section', 'mt-font-drawer'); sheet.setAttribute('aria-label', w.font);
    const top = h('div', 'mt-eng-card-head');
    const close = btn('mt-eng-key', w.ok); close.onclick = () => this.close();
    top.append(h('h2', 'mt-eng-card-title', w.font), close);
    this.picker = fontPicker(session, 'grid'); sheet.append(top, this.picker.root); this.root.append(sheet);
    this.root.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.close(); }
    });
    this.root.onclick = event => { if (event.target === this.root) this.close(); };
    this.trigger.onclick = () => {
      (document.activeElement as HTMLElement | null)?.blur();
      const host = this.trigger.closest('.mt-root') ?? document.body;
      host.append(this.root); this.root.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true'); this.refresh();
      this.release = modalFocus(sheet, () => this.close());
    };
    this.refresh();
  }
  refresh(): void { this.picker.refresh(); this.trigger.textContent = `${ew().font} · ${this.session.font.name} ⌃`; }
  close(): void {
    this.root.hidden = true; this.trigger.setAttribute('aria-expanded', 'false');
    this.release?.(); this.release = null;
    if (this.trigger.isConnected && this.trigger.getClientRects().length) this.trigger.focus({ preventScroll: true });
  }
  destroy(): void { this.close(); this.root.remove(); }
}
